module.exports = __webpack_public_path__ + "img/bannerCfm.69104af5.png";